import { useTranslation } from 'react-i18next';

import FormStepWrapper from 'components/form/FormStepWrapper';
import ChoicePicker, { ChoiceOption } from 'components/inputs/ChoicePicker';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import ContactSupportButton from 'features/my-profile/become-fundraiser/form/components/ContactSupportButton';
import SkipButton from 'features/my-profile/become-fundraiser/form/components/SkipButton';

const VerifyAccountType = () => {
  const { t } = useTranslation('myProfile');
  const { formData, errors, setFieldValue } = useBecomeFundraiser();

  const options: ChoiceOption[] = [
    {
      key: 'CHECKING',
      name: t('become-fundraiser.verify-account-type.account-type-checking'),
      isActive: formData.accountType === 'CHECKING',
    },
    {
      key: 'SAVINGS',
      name: t('become-fundraiser.verify-account-type.account-type-saving'),
      isActive: formData.accountType === 'SAVINGS',
    },
  ];

  const handleSelect = (key: string) => setFieldValue('accountType', key);

  return (
    <FormStepWrapper
      header={t('become-fundraiser.verify-account-type.header')}
      description={t('become-fundraiser.verify-account-type.description')}
      isValid={!errors.accountType}>
      <ChoicePicker options={options} onSelect={handleSelect} />
      <ContactSupportButton />
      <SkipButton />
    </FormStepWrapper>
  );
};

export default VerifyAccountType;
